<template>
  <select-dict
    v-model="currentGlassSort"
    :selectList="glassSortsList"
    :select-first-item="true"
  />
</template>

<script setup lang="ts">
import { computed, defineModel, watch, ref } from "vue";

import SelectDict from "@/components/UI/SelectDict.vue";
import { useDictStore } from "@/stores/dictStore";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { usePartitionStore } from "@/stores/new/partition.store";
import { Dictionary } from "@/models/dictionary";

const dictStore = useDictStore();
const partitionsStore = usePartitionStore();
const estimateStore = useNewEstimateStore();

const installationSystem = computed(
  () => estimateStore.estimate.installedSystemCode,
);
const activeStructureType = computed(
  () => partitionsStore.activeGlassThinknessPartition?.structureType,
);

const availableGlassSorts = dictStore.findGlassSort(installationSystem.value);
const glassSortsList = ref<Dictionary[]>([]);
const currentGlassSort = defineModel<string>();

watch(
  () => availableGlassSorts,
  () => {
    glassSortsList.value = availableGlassSorts;
  },
  {
    immediate: true,
  },
);

const filterGlassSorts = (el) => {
  const glassType = dictStore.findGlassSortThicknesses(el.code);
  const glassThickness = glassType?.thicknesses?.find(
    (thick) => thick === activeStructureType.value,
  );

  return glassThickness;
};

watch(
  () => currentGlassSort.value,
  () => {
    const filteredGlassSorts = availableGlassSorts.filter((el) => {
      const glassThickness = filterGlassSorts(el);
      if (glassThickness) {
        return el;
      }
    });

    glassSortsList.value = filteredGlassSorts;
  },
  {
    immediate: true,
  },
);
</script>

<style lang="scss" scoped></style>
